(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // VC – thin scroll indicator line under the collection links
  (() => {
    const init = () => {
      const scroller = document.querySelector('[data-vc-collnav-scroll]');
      const thumb = document.querySelector('[data-vc-collnav-thumb]');
      if (!scroller || !thumb) return;

      const track = thumb.parentElement;

      const update = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 1) {
          track.style.display = 'none';
          return;
        }
        track.style.display = '';
        const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
        const thumbWidth = Math.max(visibleRatio * 100, 15);
        const progress = scroller.scrollLeft / maxScroll;
        const offset = progress * (100 - thumbWidth);
        thumb.style.width = thumbWidth + '%';
        thumb.style.transform = 'translateX(' + (offset / thumbWidth) * 100 + '%)';
      };

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  // VC – House of Errors style view cycle: 4 columns -> 6 (small) -> 3 (large) -> 4
  (() => {
    const init = () => {
      const btn = document.querySelector('[data-vc-viewtoggle]');
      if (!btn) return;

      const KEY = 'vc-grid-cols';
      const grid = () => document.querySelector('.product-grid');

      const apply = (cols) => {
        const g = grid();
        if (!g) return;
        g.classList.toggle('vc-grid--c3', cols === '3');
        g.classList.toggle('vc-grid--c6', cols === '6');
        g.setAttribute('product-grid-view', 'default');
        try {
          sessionStorage.setItem(KEY, cols);
          sessionStorage.removeItem('product-grid-view-desktop');
          sessionStorage.removeItem('product-grid-view-mobile');
        } catch (e) { /* no-op */ }
        btn.textContent = cols === '4' ? 'View small' : cols === '6' ? 'View large' : 'View medium';
      };

      let cols = '4';
      try { cols = sessionStorage.getItem(KEY) || '4'; } catch (e) { /* no-op */ }
      if (cols !== '3' && cols !== '4' && cols !== '6') cols = '4';
      apply(cols);

      btn.addEventListener('click', () => {
        cols = cols === '4' ? '6' : cols === '6' ? '3' : '4';
        apply(cols);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // VC – thin scroll indicator line under the collection links (homepage bar)
  (() => {
    const init = () => {
      const scroller = document.querySelector('.vc-collbar--home [data-vc-collnav-scroll]');
      const thumb = document.querySelector('.vc-collbar--home [data-vc-collnav-thumb]');
      if (!scroller || !thumb) return;

      const track = thumb.parentElement;

      const update = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 1) {
          track.style.display = 'none';
          return;
        }
        track.style.display = '';
        const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
        const thumbWidth = Math.max(visibleRatio * 100, 15);
        const progress = scroller.scrollLeft / maxScroll;
        const offset = progress * (100 - thumbWidth);
        thumb.style.width = thumbWidth + '%';
        thumb.style.transform = 'translateX(' + (offset / thumbWidth) * 100 + '%)';
      };

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
